<template>
  <div v-show="$route.meta && $route.meta.routeTitle" id="app">
    <nav-bar v-if="showNavBar && !isH5"></nav-bar>
    <Search v-if="showH5Search" />
    <OpenApp
      v-if="
        isH5 && !isElectron && !isHXApp && !isMini && !$route.meta.noOpenApp
      "
    />
    <component :is="layout"> </component>
    <div v-if="showFooter">
      <H5Footer v-if="isShowH5Footer" />
      <common-footer v-else></common-footer>
    </div>
    <!-- 咨询入口 -->
    <ConsultEntry v-if="showConsultEntry && !hideCourseHelper" />
  </div>
</template>
<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import {
  ConsultEntry,
  isHXApp,
  isMini,
  isMGAppInPad,
  isH5,
  CommonFooter,
  NavBar,
} from "@saas/components/src";
import H5Footer from "./components/H5Footer";
import Search from "./components/Search.vue";
import OpenApp from "./components/OpenApp";

export default {
  data() {
    return {
      isH5: isH5(),
      isHXApp: isHXApp(),
      isMini: isMini(),
      default_layout: "default-page",
      isElectron: window.isElectron,
      hideCourseHelper: false,
    };
  },
  computed: {
    showH5Search() {
      let routerName = ["Home", "CourseList"];
      return (
        this.showNavBar && this.isH5 && routerName.includes(this.$route.name)
      );
    },
    showConsultEntry() {
      if (this.isH5) {
        return false;
      } else if (this.$route.meta.showConsultEntry) {
        return true;
      } else {
        return false;
      }
    },
    layout() {
      return this.$route.meta.layout || this.default_layout;
    },
    showNavBar() {
      if (window.isElectron) {
        return false;
      } else {
        return !this.$route.meta.noNavBar && !this.isHXApp && !this.isMini;
      }
    },
    showFooter() {
      if (window.isElectron) {
        return false;
      } else {
        return !this.$route.meta.nofooter && !this.isHXApp && !this.isMini;
      }
    },
    isShowH5Footer() {
      return this.$store.state.common.showH5Footer;
    },
  },
  mounted() {
    // this.$offlineDialog();
    window.addEventListener("join-live-room-over", this.stopLoading, true);
    // this.$nextTick(() => {
    //   this.handlePadAppStyle();
    // });
    EventBus.$off("hideCourseHelper");
    EventBus.$on("hideCourseHelper", (val) => {
      this.hideCourseHelper = val;
    });
    if (this.isH5) {
      this.$store.commit("common/setShowH5Footer", true);
    } else {
      this.$store.commit("common/setShowH5Footer", false);
    }
  },
  beforeDestroy() {
    window.removeEventListener("join-live-room-over", this.stopLoading, true);
  },
  methods: {
    // pad-app 样式适配
    handlePadAppStyle() {
      let routerNames = ["Payment", "PayResult", "groupInfo"];
      console.log(this.$route, "====");
      if (
        (isMGAppInPad() && isH5()) ||
        (isMGAppInPad() && routerNames.includes(this.$route.name))
      ) {
        document.querySelector("html").classList.add("pad-app-html");
      }
    },
    stopLoading() {
      console.log("stopLoading--app");
      // this.pageLoading = false;
      this.$saasLoadingClose();
    },
  },
  components: {
    "nav-bar": NavBar,
    "common-footer": CommonFooter,
    H5Footer,
    Search,
    ConsultEntry,
    OpenApp,
  },
  watch: {
    "$route.name": {
      immediate: true, // 组件创建时立即触发
      handler() {
        this.handlePadAppStyle();
      },
    },
    showH5Search: {
      immediate: true, // 组件创建时立即触发
      handler(newValue) {
        if (newValue) {
          document
            .getElementsByTagName("body")[0]
            .style.setProperty("--h5-search-height", `1.33rem`);
        } else {
          document
            .getElementsByTagName("body")[0]
            .style.setProperty("--h5-search-height", `0px`);
        }
      },
    },
  },
};
</script>
<style lang="scss">
.pad-app-html {
  font-size: 37.5px !important;
}
@import "@/assets/scss/main.scss";
#app {
  font-family: PingFangSC, PingFang SC;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  background: $chiral-background-color;
}
.content,
.live-content {
  margin: 0 auto;
  flex: 1 0 auto;
  width: 100%;
  width: 1200px;
  min-height: calc(100vh - 300px);
  font-size: 14px;
  color: $chiral-color;
  background: $saas-bg-color;
}
@media (max-width: 767px) {
  .content {
    min-height: 100vh;
  }
}
html {
  word-spacing: 1px;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  box-sizing: border-box;
}

*,
*::before,
*::after {
  box-sizing: border-box;
  margin: 0;
}
.el-button--primary {
}
.el-button--primary:hover,
.el-button--primary:focus {
  background: $saas-theme-color !important;
  border-color: $saas-theme-color !important;
  color: #fff;
}
.el-button--primary.is-disabled,
.el-button--primary.is-disabled:active,
.el-button--primary.is-disabled:focus,
.el-button--primary.is-disabled:hover {
  color: $saas-theme-color !important;
  background-color: rgba($color: $saas-theme-color, $alpha: 0.2) !important;
  border: none !important;
}
</style>
